import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  CircularProgress,
  IconButton,
  Grid,
  Divider,
  Button,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate, useParams } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import axios from "api/baseurl";

function FullCasePage() {
  const navigate = useNavigate();
  const { patientId } = useParams();
const [selectedTab, setSelectedTab] = useState("patient");
  const [loading, setLoading] = useState(true);
  const [caseSummary, setCaseSummary] = useState(null);

  const token = JSON.parse(localStorage.getItem("loginData"))?.token;

  const fetchCaseSummary = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        "/api/patientregistration/patient-case-summary",
        {
          patientId: patientId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Patient Case Summary:", response.data);

      setCaseSummary(response.data);
    } catch (error) {
      console.error("Error fetching case summary:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (patientId) {
      fetchCaseSummary();
    }
  }, [patientId]);
  const textStyle = {
  fontSize: "13px",
  color: "#334155",
  lineHeight: 1.8,
};

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            maxWidth: "1200px",
            margin: "0 auto",
            pb: 4,
          }}
        >
          {/* Header */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 3,
              mt: 2,
            }}
          >
            <IconButton
              onClick={() => navigate(-1)}
              sx={{
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              }}
            >
              <ArrowBackIosNewIcon />
            </IconButton>

            <Typography
              sx={{
                flex: 1,
                textAlign: "center",
                fontSize: "28px",
                fontWeight: 700,
                color: "#1A237E",
                mr: 5,
              }}
            >
              Full Case Summary
            </Typography>
          </Box>

          {/* Patient Info */}
<Card
  sx={{
    p: 3,
    borderRadius: "18px",
    bgcolor: "#FFFFFF",
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 16px rgba(15,23,42,0.08)",
  }}
>
  {/* Tabs */}
  <Box
    sx={{
      display: "flex",
      gap: 1,
      flexWrap: "wrap",
      mb: 3,
      p: 1,
      borderRadius: "14px",
      bgcolor: "#F8FAFC",
      border: "1px solid #E2E8F0",
    }}
  >
    {[
      { key: "patient", label: "Patient Details" },
      { key: "clinical", label: "Clinical Records" },
      { key: "medications", label: "Medications" },
      { key: "doctor", label: "Doctor Details" },
      { key: "device", label: "Device Readings" },
    ].map((tab) => (
      <Button
        key={tab.key}
        onClick={() => setSelectedTab(tab.key)}
        sx={{
          borderRadius: "12px",
          px: 3,
          py: 1,
          minWidth: "140px",
          textTransform: "none",
          fontSize: "13px",
          fontWeight: 600,
          transition: "all 0.3s ease",

          bgcolor:
            selectedTab === tab.key
              ? "#2563EB"
              : "transparent",

          color:
            selectedTab === tab.key
              ? "#fff"
              : "#475569",

          boxShadow:
            selectedTab === tab.key
              ? "0 4px 12px rgba(37,99,235,0.25)"
              : "none",

          "&:hover": {
            bgcolor:
              selectedTab === tab.key
                ? "#1D4ED8"
                : "#E2E8F0",
          },
        }}
      >
        {tab.label}
      </Button>
    ))}
  </Box>

  <Divider sx={{ mb: 3 }} />

  {/* Patient Details */}
  {selectedTab === "patient" && (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Typography sx={textStyle}>
          <strong>Name:</strong>{" "}
          {caseSummary?.patientRegistration?.firstname}{" "}
          {caseSummary?.patientRegistration?.lastname}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography sx={textStyle}>
          <strong>Age:</strong>{" "}
          {caseSummary?.patientRegistration?.age}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography sx={textStyle}>
          <strong>Gender:</strong>{" "}
          {caseSummary?.patientRegistration?.gender}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography sx={textStyle}>
          <strong>Phone:</strong>{" "}
          {caseSummary?.patientRegistration?.phoneNumber}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography sx={textStyle}>
          <strong>Email:</strong>{" "}
          {caseSummary?.patientRegistration?.email}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography sx={textStyle}>
          <strong>Address:</strong>{" "}
          {caseSummary?.patientRegistration?.address}
        </Typography>
      </Grid>
    </Grid>
  )}

  {/* Clinical Records */}
  {selectedTab === "clinical" &&
    caseSummary?.clinicalRecords?.map((record) => (
      <Card
        key={record.id}
        sx={{
          p: 2.5,
          mb: 2,
          borderRadius: "14px",
          bgcolor: "#F8FAFC",
          border: "1px solid #E2E8F0",
        }}
      >
        <Typography sx={textStyle}>
          <strong>Diagnosis:</strong> {record.diagnosis}
        </Typography>

        <Typography sx={textStyle}>
          <strong>Decision:</strong> {record.decision}
        </Typography>

        <Typography sx={textStyle}>
          <strong>Follow Up:</strong> {record.followUp}
        </Typography>

        <Typography sx={textStyle}>
          <strong>Instructions:</strong> {record.instructions}
        </Typography>

        <Typography sx={textStyle}>
          <strong>Escalation Reason:</strong>{" "}
          {record.escalationReason}
        </Typography>
      </Card>
    ))}

  {/* Medications */}
  {selectedTab === "medications" &&
    caseSummary?.clinicalRecordMedications?.map(
      (med, index) => (
        <Card
          key={index}
          sx={{
            p: 2,
            mb: 2,
            borderRadius: "14px",
            bgcolor: "#F8FAFC",
            border: "1px solid #E2E8F0",
          }}
        >
          <Typography sx={textStyle}>{med}</Typography>
        </Card>
      )
    )}

  {/* Doctor Details */}
  {selectedTab === "doctor" &&
    caseSummary?.doctorRegistration?.map(
      (doctor) => (
        <Card
          key={doctor.id}
          sx={{
            p: 3,
            mb: 2,
            borderRadius: "14px",
            bgcolor: "#F8FAFC",
            border: "1px solid #E2E8F0",
          }}
        >
          <Typography
            sx={{
              fontSize: "17px",
              fontWeight: 700,
              color: "#1E3A8A",
              mb: 2,
            }}
          >
            Dr. {doctor.firstname} {doctor.lastname}
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={textStyle}>
                <strong>Email:</strong> {doctor.email}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={textStyle}>
                <strong>Phone:</strong>{" "}
                {doctor.phoneNumber}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={textStyle}>
                <strong>Doctor Type:</strong>{" "}
                {doctor.doctorType}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={textStyle}>
                <strong>NMC Number:</strong>{" "}
                {doctor.nmcRegisteredNumber}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography sx={textStyle}>
                <strong>Address:</strong>{" "}
                {doctor.address}
              </Typography>
            </Grid>
          </Grid>
        </Card>
      )
    )}

  {/* Device Readings */}
  {selectedTab === "device" &&
    caseSummary?.deviceData?.map((reading) => (
      <Card
        key={reading.id}
        sx={{
          p: 3,
          mb: 2,
          borderRadius: "16px",
          border: "1px solid #E2E8F0",
        }}
      >
        <Typography
          sx={{
            mb: 2,
            fontSize: "14px",
            fontWeight: 600,
            color: "#1E3A8A",
          }}
        >
          {new Date(
            reading.recordedAt
          ).toLocaleString()}
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                p: 2,
                textAlign: "center",
                borderRadius: "14px",
                bgcolor: "#EFF6FF",
                border: "1px solid #BFDBFE",
              }}
            >
              <Typography sx={textStyle}>
                BP Systolic
              </Typography>

              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 700,
                  color: "#0F172A",
                }}
              >
                {reading.bpSystolic}
              </Typography>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card
              sx={{
                p: 2,
                textAlign: "center",
                borderRadius: "14px",
                bgcolor: "#FEF2F2",
                border: "1px solid #FECACA",
              }}
            >
              <Typography sx={textStyle}>
                BP Diastolic
              </Typography>

              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 700,
                  color: "#0F172A",
                }}
              >
                {reading.bpDiastolic}
              </Typography>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card
              sx={{
                p: 2,
                textAlign: "center",
                borderRadius: "14px",
                bgcolor: "#F0FDF4",
                border: "1px solid #BBF7D0",
              }}
            >
              <Typography sx={textStyle}>
                BP Mean
              </Typography>

              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 700,
                  color: "#0F172A",
                }}
              >
                {reading.bpMean}
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Card>
    ))}
</Card>
      
  
        </Box>
      )}
    </DashboardLayout>
  );
}

export default FullCasePage;